import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    'timeline-label': {
      '& .ant-timeline-item-label': {
        width: '90px !important',
      },

      '& .ant-timeline-item-tail': {
        left: '100px !important',
      },

      '& .ant-timeline-item-head': {
        left: '100px !important',
      },

      '& .ant-timeline-item-content': {
        left: '110px !important',
        width: 'auto  !important',
      },
    },
    'calendard-event-badge': {
      fontSize: '12px',
    },
    '.ant-badge-status-text': {
      fontSize: '12px',
    },
    'calendar-title': {
      margin: '0 25px 0 0',
    },
    'calendar-title-container': {
      display: 'flex',
      flexDirection: 'column',
    },
    'calendar-title-row': {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    'calendar-title--stats': {
      'display': 'flex',
      'flexDirection': 'column',
      'alignItems': 'center',
      'flexWrap': 'wrap',
      'marginLeft': 'auto',
      // '@media (max-width: 870px)': {
      '@media (max-width: 1384px)': {
        margin: 0,
        marginLeft: 5,
      },
    },
    'calendar-title-days': {
      'display': 'flex',
      'alignItems': 'center',
      'flexWrap': 'wrap',
      'marginRight': 10,
      '@media (max-width: 950px)': {
        fontSize: '14px',
      },
    },
    'calendar-title--log-button': {
      'margin': '10px 40px 10px 30px',
      '@media (max-width: 700px)': {
        margin: 'unset',
      },
      // '@media (max-width: 1150px)': {
      '@media (max-width: 1700px)': {
        marginLeft: 'auto',
      },
    },
    'calendar-title--add-activity-button': {
      margin: '10px 0',
    },
    'calendar-title--alert': {
      margin: '0 5px 0 30px',
    },
    'drawer-header--extra': {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    'custom-activity--duration': {
      margin: '10px',
    },
    'client-list-skeleton': {
      '& .ant-skeleton-title': {
        marginBottom: 0,
      },
    },
    'client-show-stats-child': {
      'flex': '0 1 48%',
      'boxSizing': 'border-box',
      'padding': 10,
      '@media (max-width: 900px)': {
        flexBasis: '100%',
        margin: 0,
      },
    },
    'activity-log-root': {
      '& .ant-drawer-header-title': {
        minWidth: '175px !important',
      },
      '& .ant-drawer-extra': {
        flex: 'unset',
        display: 'flex',
        flexWrap: 'wrap',
      },
    },
  };
});
export default useStyles;
